import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardHeader,
  CardBody,
  Label,
  CardFooter,
} from "reactstrap";
import { useSafariPaymentReset } from "../../../hooks/useSafariPaymentReset";
import CustomInput from "../../../custom/CustomInput";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch, batch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CircularLoading from "../../loader/CircularIndeterminate";
import CustomSelect from "../../../custom/CustomSelect";
import { Autocomplete, TextField } from "@mui/material";

const DanceLatest = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  const { courseByEvents } = useSelector((state) => state.courseByEvents);

  useEffect(() => {
    dispatch(actions.courseByEventsGetData({ id: "37" }));
    // dispatch(actions.batchesGetData());
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    const coursereg = {
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      course_id: values.course_id,
      date: values.date,
      preferred_day: values.preferred_day,
      preferred_time: values.preferred_time,
      student_no: values.student_no,
      totalfees: values.totalfees,
      is_online_payment: values.is_online_payment,
      is_enquiry: values.is_enquiry,
    };
    // iOS Safari compatible redirect
    dispatch(
      actions.postCourseregDataWithBackendRedirect(coursereg, setSubmitting, navigate)
    );
    setSubmitting(true);
    return;
  };
  const defaultProps = {
    options: courseByEvents,
    getOptionLabel: (option) => option.name,
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  clientemail: "",
                  clientphone: "",
                  course_id: "",
                  date: "",
                  preferred_day: "",
                  preferred_time: "",
                  student_no: "",
                  totalfees: "0",
                  is_online_payment: "1",
                  is_enquiry: "0",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("This field is Required"),
                  clientphone: Yup.string().required("This field is Required"),
                  student_no: Yup.string().required("This field is Required"),
                })}
              >
                {(formProps) => {
                  //   formProps.values.totalfees =
                  //     formProps.values.student_no == "1"
                  //       ? "499"
                  //       : formProps.values.student_no == "2"
                  //       ? "699"
                  //       : "0";
                  return (
                    <Form className="mt-3">
                      {console.log("formProps", formProps.values)}
                      <Row className="form-group mt-3">
                        <Col md={6}>
                          <Label htmlFor="clientname" className="label">
                            Your Full Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientname"
                              id="clientname"
                              placeholder="Enter Your Name"
                              className={
                                "form-control" +
                                (formProps.errors.clientname &&
                                formProps.touched.clientname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientname"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6}>
                          <Label htmlFor="clientphone" className="label">
                            Your Mobile:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="number"
                              name="clientphone"
                              id="clientphone"
                              placeholder="Enter Your Mobile Numbar"
                              className={
                                "form-control" +
                                (formProps.errors.clientphone &&
                                formProps.touched.clientphone
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientphone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={6}>
                          <Label htmlFor="clientemail" className="label">
                            Your Email:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientemail"
                              id="clientemail"
                              placeholder="Enter Your Email ID"
                              className={
                                "form-control" +
                                (formProps.errors.clientemail &&
                                formProps.touched.clientemail
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientemail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6}>
                          <Label htmlFor="course_id" className="label">
                            Your Course:
                          </Label>
                          <InputGroup>
                            <Autocomplete
                              {...defaultProps}
                              getOptionSelected={(option, value) =>
                                option.id === value.id
                              }
                              id="course_id"
                              name="course_id"
                              onChange={(event, newValue) => {
                                console.log("new", newValue);
                                formProps.setFieldValue(
                                  `course_id`,
                                  newValue?.id ?? ""
                                );
                                formProps.setFieldValue(
                                  `date`,
                                  newValue?.date ?? ""
                                );
                                formProps.setFieldValue(
                                  `preferred_day`,
                                  newValue?.day ?? ""
                                );
                                formProps.setFieldValue(
                                  `preferred_time`,
                                  newValue?.time ?? ""
                                );
                                formProps.setFieldValue(
                                  `student_no`,
                                  newValue?.passes ?? ""
                                );

                                formProps.setFieldValue(
                                  `totalfees`,
                                  newValue?.total_amount ?? ""
                                );
                              }}
                              sx={{ width: "100%" }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Course Name *"
                                  variant="outlined"
                                  name="course_id"
                                  size="small"
                                  className="form-control"
                                  error={
                                    formProps.touched.course_id &&
                                    Boolean(formProps.errors.course_id)
                                  }
                                  helperText={
                                    formProps.touched.course_id &&
                                    formProps.errors.course_id
                                  }
                                />
                              )}
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={6}>
                          <Label htmlFor="totalfees" className="label">
                            Your Amount:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="totalfees"
                              id="totalfees"
                              disabled
                              placeholder="Enter Your Amount"
                              className={
                                "form-control" +
                                (formProps.errors.totalfees &&
                                formProps.touched.totalfees
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="totalfees"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6}>
                          <Label htmlFor="date" className="label">
                            Your Date:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="date"
                              id="date"
                              disabled
                              placeholder="Enter Your Date"
                              className={
                                "form-control" +
                                (formProps.errors.date && formProps.touched.date
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="date"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={6}>
                          <Label htmlFor="preferred_day" className="label">
                            Your Day:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="preferred_day"
                              id="preferred_day"
                              disabled
                              placeholder="Enter Your Date"
                              className={
                                "form-control" +
                                (formProps.errors.preferred_day &&
                                formProps.touched.preferred_day
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="preferred_day"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6}>
                          <Label htmlFor="preferred_time" className="label">
                            Your Time:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="preferred_time"
                              id="preferred_time"
                              disabled
                              placeholder="Enter Your Date"
                              className={
                                "form-control" +
                                (formProps.errors.preferred_time &&
                                formProps.touched.preferred_time
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="preferred_time"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {/* <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="student_no" className="label">
                            Select Your Pass:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="student_no"
                              id="student_no"
                              //   placeholder="Enter Your Date"
                              className={
                                "form-control" +
                                (formProps.errors.student_no &&
                                formProps.touched.student_no
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select Your Pass</option>
                              <option value={"1"}>Single</option>
                              <option value={"2"}>Couple</option>
                            </Field>
                            <ErrorMessage
                              name="student_no"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row> */}

                      <div className="mt-3 mb-3 row mt-5">
                        <div className="col-12">
                          <Button
                            type="submit"
                            className="register-btn"
                            size="md"
                            block
                          >
                            {isPostLoading ? <CircularLoading /> : "PAY NOW"}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default DanceLatest;
